/**
 * Display formatting for Swedish organisation and personal numbers: a value
 * of 10 or 12 digits (spaces and hyphens ignored) whose last 10 digits pass
 * the Luhn check gets a hyphen before the last four. Anything else is
 * returned unchanged, so foreign ids, "+"-numbers and typos print as typed.
 */
export function formatSwedishLegalId(value) {
    if (!/^[\d\s-]+$/.test(value))
        return value;
    const digits = value.replace(/[\s-]/g, '');
    if (digits.length !== 10 && digits.length !== 12)
        return value;
    if (!luhnValid(digits.slice(-10)))
        return value;
    return `${digits.slice(0, -4)}-${digits.slice(-4)}`;
}
function luhnValid(digits) {
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
        let d = Number(digits[i]);
        if (i % 2 === 0) {
            d *= 2;
            if (d > 9)
                d -= 9;
        }
        sum += d;
    }
    return sum % 10 === 0;
}
//# sourceMappingURL=legal-id.js.map